import React, { memo } from "react";
import { translate } from "lib";
import { FieldHint } from "v2/components/shared";

const Label = ({
	name,
	label,
	tooltip,
	children
}: {
	name?: string;
	label?: string;
	/**
	 * Guidance shown on hover via an info icon beside the label. Prefer this over
	 * `hint`, which Feedback renders as permanent text under the field.
	 */
	tooltip?: string;
	children?: JSX.Element | JSX.Element[] | any;
}) => (
	<label htmlFor={`form-control-input-${name}`}>
		<span>{translate(`${label || name}`)}</span>
		{!!tooltip && <FieldHint text={tooltip} />}
		{children}
	</label>
);

export default memo(Label);
